import { useEffect, useState } from "react";
import { createGenericContext } from "../../utils/createGenericContext";
import clinicalUserService from "../../services/clinical-user-service";
import { useNavigate } from "react-router-dom";

export interface IClinicalAccountContext {
  isClinician: boolean | null;
  doClinicianLogout: () => void;
  setLoggedIn: () =>void
}

const [useClinicalAccount, ClinicalAccountContextProvider] =
  createGenericContext<IClinicalAccountContext>();

const ClinicalAccountProvider = ({ children }: any) => {
  const [isClinician, setIsClinician] = useState<boolean | null>(null);
  const navigate = useNavigate()

  useEffect(() => {
    clinicalUserService
      .getUser()
      .then((res) => {
        setIsClinician(true);
      })
      .catch(() => {
        setIsClinician(false);
      });
  }, []);

  const setLoggedIn = () => {
    setIsClinician(true)
  }

  const doClinicianLogout = () => {
      clinicalUserService.logout().then(() => {
        navigate("/logged-out")
      }).catch(() => {
        navigate("/logged-out")
      })
  };

  let contextValue = {
    isClinician,
    doClinicianLogout,
    setLoggedIn
  };

  return (
    <ClinicalAccountContextProvider value={contextValue}>
      {children}
    </ClinicalAccountContextProvider>
  );
};

export { ClinicalAccountProvider, useClinicalAccount };
